import axios from 'axios'
import { CLIENTES_ENDPOINT } from 'cfgCommon/endpoints'

export async function getCliente(id) {
  const response = await axios(`${CLIENTES_ENDPOINT}/${id}`)
  return response?.data?.data
}
